import { render } from "./UploadOvaContent.vue?vue&type=template&id=5b211064&scoped=true"
import script from "./UploadOvaContent.vue?vue&type=script&lang=js"
export * from "./UploadOvaContent.vue?vue&type=script&lang=js"

import "./UploadOvaContent.vue?vue&type=style&index=0&id=5b211064&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b211064"]])

export default __exports__